import { SaveOutlined } from '@ant-design/icons';
import { Button, Col, Row, Tabs, Input } from 'antd';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { currencyFormat } from '../../helpers/common';
import { layThongTinCauHinhLuong, luuCauHinhLuong } from '../../services/setting';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const CauHinhLuongTab = () => {
    const [openModalLuu, setOpenModalLuu] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { handleChange, values, handleSubmit, touched, errors, setFieldValue, setErrors, setTouched } = useFormik({
        initialValues: {
            congDoanMax: 0,
            congDoanMax_Str: "",
            heSo_LCB_NQL: 0,
            mucLuongDongBH_NQL: 0,
            mucLuongDongBH_NQL_Str: "",
            themGio_NgayThuong: 0,
            themGio_NgayLe: 0,
            themGio_NgayNghi: 0,
            thuLao_CTHDQL: 0,
            thuLao_CTHDQL_Str: "",
            thuLao_PCTHDQL: 0,
            thuLao_PCTHDQL_Str: "",
            thuLao_TVHDQL: 0,
            thuLao_TVHDQL_Str: "",
        },
        validationSchema: Yup.object({
            congDoanMax: Yup.number().required('Bắt buộc'),
            congDoanMax_Str: Yup.string().required('Bắt buộc'),
            heSo_LCB_NQL: Yup.number().required('Bắt buộc').max(100, 'Giá trị không được lớn hơn 100').min(0, 'Giá trị không được nhỏ hơn 0'),
            mucLuongDongBH_NQL: Yup.number().required('Bắt buộc'),
            mucLuongDongBH_NQL_Str: Yup.string().required('Bắt buộc'),
            themGio_NgayThuong: Yup.number()
                .required('Bắt buộc')
                .min(0, 'Không được nhỏ hơn 0')
                .max(100, 'Không được lớn hơn 100')
                .test('max-decimals', 'Tối đa 2 chữ số thập phân', (value) => {
                    if (value === undefined || value === null) return true;
                    return /^\d+(\.\d{1,2})?$/.test(String(value));
                }),
            themGio_NgayNghi: Yup.number()
                .required('Bắt buộc')
                .min(0)
                .test('max-decimals', 'Tối đa 2 chữ số thập phân', (value) => {
                    if (value === undefined || value === null) return true;
                    return /^\d+(\.\d{1,2})?$/.test(String(value));
                }),
            themGio_NgayLe: Yup.number()
                .required('Bắt buộc')
                .min(0)
                .test('max-decimals', 'Tối đa 2 chữ số thập phân', (value) => {
                    if (value === undefined || value === null) return true;
                    return /^\d+(\.\d{1,2})?$/.test(String(value));
                }),
            thuLao_CTHDQL: Yup.number().required('Bắt buộc'),
            thuLao_CTHDQL_Str: Yup.string().required('Bắt buộc'),
            thuLao_PCTHDQL: Yup.number().required('Bắt buộc'),
            thuLao_PCTHDQL_Str: Yup.string().required('Bắt buộc'),
            thuLao_TVHDQL: Yup.number().required('Bắt buộc'),
            thuLao_TVHDQL_Str: Yup.string().required('Bắt buộc'),
        }),
        onSubmit: (values) => {
            setOpenModalLuu(true);
        }
    });
    const layThongTin = async () => {
        dispatch(showLoadingScreen());
        var data = await layThongTinCauHinhLuong();
        setFieldValue("congDoanMax", data.congDoanMax || 0);
        setFieldValue("congDoanMax_Str", currencyFormat.formatMoney(data.congDoanMax))
        setFieldValue("heSo_LCB_NQL", data.heSo_LCB_NQL || 0);
        setFieldValue("mucLuongDongBH_NQL", data.mucLuongDongBH_NQL || 0);
        setFieldValue("mucLuongDongBH_NQL_Str", currencyFormat.formatMoney(data.mucLuongDongBH_NQL));
        setFieldValue("themGio_NgayThuong", data.themGio_NgayThuong || 0);
        setFieldValue("themGio_NgayLe", data.themGio_NgayLe || 0);
        setFieldValue("themGio_NgayNghi", data.themGio_NgayNghi || 0);
        setFieldValue("thuLao_CTHDQL", data.thuLao_CTHDQL || 0);
        setFieldValue("thuLao_CTHDQL_Str", currencyFormat.formatMoney(data.thuLao_CTHDQL));
        setFieldValue("thuLao_PCTHDQL", data.thuLao_PCTHDQL || 0);
        setFieldValue("thuLao_PCTHDQL_Str", currencyFormat.formatMoney(data.thuLao_PCTHDQL));
        setFieldValue("thuLao_TVHDQL", data.thuLao_TVHDQL || 0);
        setFieldValue("thuLao_TVHDQL_Str", currencyFormat.formatMoney(data.thuLao_TVHDQL));
        dispatch(hideLoadingScreen());
    }

    const onSave = async (request: any) => {
        try {
            dispatch(showLoadingScreen());
            var data = {
                congDoanMax: request.congDoanMax,
                heSo_LCB_NQL: request.heSo_LCB_NQL,
                mucLuongDongBH_NQL: request.mucLuongDongBH_NQL,
                themGio_NgayThuong: request.themGio_NgayThuong,
                themGio_NgayLe: request.themGio_NgayLe,
                themGio_NgayNghi: request.themGio_NgayNghi,
                thuLao_CTHDQL: request.thuLao_CTHDQL,
                thuLao_PCTHDQL: request.thuLao_PCTHDQL,
                thuLao_TVHDQL: request.thuLao_TVHDQL,
            };
            let rs = await luuCauHinhLuong(data);
            setErrors({});
            setTouched({});
            toast.success('Lưu cấu hình lương thành công!');
            dispatch(hideLoadingScreen());
            setOpenModalLuu(false)
        }
        catch (err: any) {
            dispatch(hideLoadingScreen());
            toast.error('Đã xảy ra lỗi, lưu không thành công!');
            setOpenModalLuu(false);
        }

    };

    const handleChangeDecimal = (e: any) => {
        const { name, value } = e.target;

        // chỉ cho số + dấu .
        let val = value.replace(/[^0-9.]/g, '');

        // chỉ 1 dấu .
        val = val.replace(/(\..*)\./g, '$1');

        // giới hạn 2 số sau dấu .
        if (val.includes('.')) {
            const [int, dec] = val.split('.');
            val = `${int}.${dec.slice(0, 2)}`;
        }

        setFieldValue(name, val);
    };

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { name, value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        const format = currencyFormat.formatMoney(parsedValue);

        setFieldValue(name, format);
        setFieldValue(name.replace('_Str', ''), parsedValue);
    };


    useEffect(() => {
        layThongTin();
    }, []);
    return <section>

        {openModalLuu && <ModalTextForm show={openModalLuu}
            title="Lưu thông tin"
            handleClose={() => setOpenModalLuu(false)}
            handleSave={() => { onSave(values); }}>
            Xác nhận lưu thông tin cấu hình lương?
        </ModalTextForm>}
        <Row>
            <Col span={24}>
                <form onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
                    <Tabs
                        tabBarExtraContent={
                            <Button
                                htmlType="submit"
                                icon={<SaveOutlined rev="" />}
                                type="primary"
                            >
                                Lưu
                            </Button>
                        }
                        defaultActiveKey="1" items={[
                            {
                                key: '1',
                                label: 'Cấu hình lương',
                                children:
                                    <div className="card pt-3 pb-2">
                                        <div className="form-group row col-sm-12">
                                            <label className="col-sm-3 control-label"><span className="text-red">*</span> Số tiền công đoàn tối đa : </label>
                                            <div className="col-sm-3">
                                                <Form.Control
                                                    id="congDoanMax_Str"
                                                    name="congDoanMax_Str"
                                                    type="text"
                                                    placeholder="Số tiền công đoàn tối đa"
                                                    onChange={handleChangeCurrency}
                                                    value={values.congDoanMax_Str}
                                                    isValid={touched.congDoanMax_Str && !errors.congDoanMax_Str}
                                                    isInvalid={touched.congDoanMax_Str && !!errors.congDoanMax_Str}
                                                />
                                                {touched.congDoanMax_Str && errors.congDoanMax_Str ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.congDoanMax_Str}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                                <Form.Control
                                                    id="congDoanMax"
                                                    name="congDoanMax"
                                                    hidden
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={values.congDoanMax}
                                                />
                                            </div>
                                            <label className="col-sm-3 control-label"><span className="text-red">*</span> Phần trăm lương được nhận NQL :</label>
                                            <div className="col-sm-3">
                                                <Form.Control
                                                    prefix="% "
                                                    id="heSo_LCB_NQL"
                                                    name="heSo_LCB_NQL"
                                                    type="number"
                                                    placeholder="Phần trăm lương được nhận"
                                                    onChange={handleChange}
                                                    value={values.heSo_LCB_NQL}
                                                    isValid={touched.heSo_LCB_NQL && !errors.heSo_LCB_NQL}
                                                    isInvalid={touched.heSo_LCB_NQL && !!errors.heSo_LCB_NQL}
                                                />
                                                {touched.heSo_LCB_NQL && errors.heSo_LCB_NQL ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.heSo_LCB_NQL}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row col-sm-12">
                                            <label className="col-sm-3 control-label"><span className="text-red">*</span> Mức lương đóng bảo hiểm NQL: </label>
                                            <div className="col-sm-3">
                                                <Form.Control
                                                    id="mucLuongDongBH_NQL_Str"
                                                    name="mucLuongDongBH_NQL_Str"
                                                    type="text"
                                                    placeholder="Mức lương đóng bảo hiểm"
                                                    onChange={handleChangeCurrency}
                                                    value={values.mucLuongDongBH_NQL_Str}
                                                    isValid={touched.mucLuongDongBH_NQL_Str && !errors.mucLuongDongBH_NQL_Str}
                                                    isInvalid={touched.mucLuongDongBH_NQL_Str && !!errors.mucLuongDongBH_NQL_Str}
                                                />
                                                {touched.mucLuongDongBH_NQL_Str && errors.mucLuongDongBH_NQL_Str ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.mucLuongDongBH_NQL_Str}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                                <Form.Control
                                                    id="mucLuongDongBH_NQL"
                                                    name="mucLuongDongBH_NQL"
                                                    hidden
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={values.mucLuongDongBH_NQL}
                                                />
                                            </div>
                                            <label className="col-sm-3 control-label"><span className="text-red">*</span> Hệ số thêm giờ ngày thường: </label>
                                            <div className="col-sm-3">
                                                <Form.Control
                                                    id="themGio_NgayThuong"
                                                    name="themGio_NgayThuong"
                                                    type="number"
                                                    step="0.01"
                                                    inputMode="decimal"
                                                    placeholder="Hệ số thêm giờ ngày thường"
                                                    onChange={handleChangeDecimal}
                                                    value={values.themGio_NgayThuong}
                                                    isValid={touched.themGio_NgayThuong && !errors.themGio_NgayThuong}
                                                    isInvalid={touched.themGio_NgayThuong && !!errors.themGio_NgayThuong}
                                                />
                                                {touched.themGio_NgayThuong && errors.themGio_NgayThuong ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.themGio_NgayThuong}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row col-sm-12">
                                            <label className="col-sm-3 control-label"><span className="text-red">*</span> Hệ số thêm giờ ngày nghỉ: </label>
                                            <div className="col-sm-3">
                                                <Form.Control
                                                    id="themGio_NgayNghi"
                                                    name="themGio_NgayNghi"
                                                    type="number"
                                                    placeholder="Hệ số thêm giờ ngày nghỉ"
                                                    onChange={handleChangeDecimal}
                                                    value={values.themGio_NgayNghi}
                                                    isValid={touched.themGio_NgayNghi && !errors.themGio_NgayNghi}
                                                    isInvalid={touched.themGio_NgayNghi && !!errors.themGio_NgayNghi}
                                                />
                                                {touched.themGio_NgayNghi && errors.themGio_NgayNghi ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.themGio_NgayNghi}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                            </div>
                                            <label className="col-sm-3 control-label"><span className="text-red">*</span> Hệ số thêm giờ ngày lễ: </label>
                                            <div className="col-sm-3">
                                                <Form.Control
                                                    id="themGio_NgayLe"
                                                    name="themGio_NgayLe"
                                                    type="number"
                                                    placeholder="Hệ số thêm giờ ngày lễ"
                                                    onChange={handleChangeDecimal}
                                                    value={values.themGio_NgayLe}
                                                    isValid={touched.themGio_NgayLe && !errors.themGio_NgayLe}
                                                    isInvalid={touched.themGio_NgayLe && !!errors.themGio_NgayLe}
                                                />
                                                {touched.themGio_NgayLe && errors.themGio_NgayLe ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.themGio_NgayLe}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                            </div>
                                        </div>
                                        <div className="form-group row col-sm-12">
                                            <label className="col-sm-3 control-label"><span className="text-red">*</span> Thù lao CTHĐQL : </label>
                                            <div className="col-sm-3">
                                                <Form.Control
                                                    id="thuLao_CTHDQL_Str"
                                                    name="thuLao_CTHDQL_Str"
                                                    type="text"
                                                    placeholder="Thù lao CTHĐQL"
                                                    onChange={handleChangeCurrency}
                                                    value={values.thuLao_CTHDQL_Str}
                                                    isValid={touched.thuLao_CTHDQL_Str && !errors.thuLao_CTHDQL_Str}
                                                    isInvalid={touched.thuLao_CTHDQL_Str && !!errors.thuLao_CTHDQL_Str}
                                                />
                                                {touched.thuLao_CTHDQL_Str && errors.thuLao_CTHDQL_Str ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.thuLao_CTHDQL_Str}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                                <Form.Control
                                                    id="thuLao_CTHDQL"
                                                    name="thuLao_CTHDQL"
                                                    hidden
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={values.thuLao_CTHDQL}
                                                />
                                            </div> <label className="col-sm-3 control-label"><span className="text-red">*</span> Thù lao PCTHĐQL : </label>
                                            <div className="col-sm-3">
                                                <Form.Control
                                                    id="thuLao_PCTHDQL_Str"
                                                    name="thuLao_PCTHDQL_Str"
                                                    type="text"
                                                    placeholder="Thù lao PCTHĐQL"
                                                    onChange={handleChangeCurrency}
                                                    value={values.thuLao_PCTHDQL_Str}
                                                    isValid={touched.thuLao_PCTHDQL_Str && !errors.thuLao_PCTHDQL_Str}
                                                    isInvalid={touched.thuLao_PCTHDQL_Str && !!errors.thuLao_PCTHDQL_Str}
                                                />
                                                {touched.thuLao_PCTHDQL_Str && errors.thuLao_PCTHDQL_Str ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.thuLao_PCTHDQL_Str}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                                <Form.Control
                                                    id="thuLao_PCTHDQL"
                                                    name="thuLao_PCTHDQL"
                                                    hidden
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={values.thuLao_PCTHDQL}
                                                />
                                            </div>
                                        </div>
                                        <div className="form-group row col-sm-12">
                                            <label className="col-sm-3 control-label"><span className="text-red">*</span> Thù lao TVHĐQL : </label>
                                            <div className="col-sm-3">
                                                <Form.Control
                                                    id="thuLao_TVHDQL_Str"
                                                    name="thuLao_TVHDQL_Str"
                                                    type="text"
                                                    placeholder="Thù lao TVHĐQL"
                                                    onChange={handleChangeCurrency}
                                                    value={values.thuLao_TVHDQL_Str}
                                                    isValid={touched.thuLao_TVHDQL_Str && !errors.thuLao_TVHDQL_Str}
                                                    isInvalid={touched.thuLao_TVHDQL_Str && !!errors.thuLao_TVHDQL_Str}
                                                />
                                                {touched.thuLao_TVHDQL_Str && errors.thuLao_TVHDQL_Str ? (
                                                    <Form.Control.Feedback type="invalid">
                                                        {errors.thuLao_TVHDQL_Str}
                                                    </Form.Control.Feedback>
                                                ) : null}
                                                <Form.Control
                                                    id="thuLao_TVHDQL"
                                                    name="thuLao_TVHDQL"
                                                    hidden
                                                    type="text"
                                                    onChange={handleChange}
                                                    value={values.thuLao_TVHDQL}
                                                />
                                            </div>
                                        </div>
                                    </div>
                            },
                        ]}>
                    </Tabs>
                </form>
            </Col>
        </Row>
    </section>
}

export default CauHinhLuongTab;